(() => {
  const mobile = window.matchMedia('(max-width: 749.98px)');
  let timer = 0;
  const roots = () => [...document.querySelectorAll('[data-reverie-contact]')];
  const syncPreferredReply = (root) => {
    const target = root.querySelector('[data-r2-review-channel]');
    if (!target) return;
    const channel = root.querySelector('[data-r2-contact-channel] input[name="msv8_channel"]:checked')?.value || 'Email';
    const number = root.querySelector('[data-reverie-contact-number]')?.value?.trim();
    const dial = root.querySelector('[data-reverie-contact-dial]')?.value?.trim();
    target.textContent = channel === 'WhatsApp' && number ? `WhatsApp · ${[dial, number].filter(Boolean).join(' ')}` : channel;
  };
  const watchRoot = (root) => {
    if (root.dataset.msInlinePatchReady === 'true') return;
    root.dataset.msInlinePatchReady = 'true';
    const form = root.querySelector('#ReverieContactForm');
    const syncLater = () => window.setTimeout(() => syncPreferredReply(root), 0);
    form?.addEventListener('input', syncLater);
    form?.addEventListener('change', syncLater);
    form?.addEventListener('click', syncLater, true);
    syncLater();
  };
  const openInline = (root) => {
    watchRoot(root);
    if (!mobile.matches || root.classList.contains('is-r2-task-open')) return true;
    const launcher = root.querySelector('[data-r2-contact-open]');
    if (!launcher) return false;
    launcher.click();
    return root.classList.contains('is-r2-task-open');
  };
  const ensureOpen = () => {
    window.clearTimeout(timer);
    let attempts = 0;
    const tick = () => {
      if (!mobile.matches) return;
      const contactRoots = roots();
      const ready = contactRoots.length > 0 && contactRoots.every(openInline);
      if (!ready && attempts < 40) { attempts += 1; timer = window.setTimeout(tick, 50); }
    };
    tick();
  };
  const restoreAfterLegacyClose = (scrollY) => {
    window.setTimeout(() => { window.scrollTo({ top: scrollY, behavior: 'auto' }); ensureOpen(); }, 0);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ensureOpen, { once: true });
  else ensureOpen();
  document.addEventListener('shopify:section:load', ensureOpen);
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !mobile.matches) return;
    if (!document.querySelector('.reverie-contact-enquiry.is-r2-task-open')) return;
    restoreAfterLegacyClose(window.scrollY);
  });
  mobile.addEventListener('change', (event) => {
    const scrollY = window.scrollY;
    if (event.matches) ensureOpen();
    else window.setTimeout(() => window.scrollTo({ top: scrollY, behavior: 'auto' }), 0);
  });
})();
